import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ProgressBar } from 'react-bootstrap';
import {
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  EmailIcon,
} from 'react-share';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SocialShare.css';

import { url } from '../../../config';
import { Text } from '../../../components_new/common';

class SocialSharing extends React.Component {
  static propTypes = {
    listId: PropTypes.number.isRequired,
  };

  render() {
    const { listId, header, iconSize = 48, title = 'listing' } = this.props;
    const shareUrl = url + '/details/' + listId;
    return (
      <div>
        {header && (
          <Text h4 pb={3}>
            {header}
          </Text>
        )}
        <div className="f-start-center f f-columns">
          <FacebookShareButton
            url={shareUrl}
            className="pr-s"
            quote={`Check out my new ${title} for rent on Yoodlize : `}
            hashtag="#yoodlize"
          >
            <FacebookIcon size={iconSize} round />
          </FacebookShareButton>
          <TwitterShareButton
            url={shareUrl}
            className="pr-s"
            title={`Check out my new ${title} for rent on Yoodlize : `}
            hashtags={['yoodlize']}
          >
            <TwitterIcon size={iconSize} round />
          </TwitterShareButton>
          <EmailShareButton
            url={shareUrl}
            subject="I have something to rent on Yoodlize"
            body={`Check out my new ${title} for rent on Yoodlize : `}
          >
            <EmailIcon size={iconSize} round />
          </EmailShareButton>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(SocialSharing);



// WEBPACK FOOTER //
// ./src/components/ViewListing/SocialShare/SocialShare.js